import React, {useContext, useEffect, useState} from 'react';
import {deleteCookie, getCookie, informLanguageChange, setCookie} from '../utils/helper';
// import useLogin from "../hooks/useLogin";


// ---------------------------------------------------------------------------------------------------------------
const isValidLanguageValue = (language) => ['en', 'gr'].includes(language);
const initLanguageValue = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const newLanguage = urlParams.get('l');
  const cookie = getCookie('LANG');
  if (urlParams.has('l') && isValidLanguageValue(newLanguage)) {
    setCookie('LANG', newLanguage, 1);
    window.sessionStorage.setItem('LANG', 'en');
    return newLanguage;
  } else if (isValidLanguageValue(cookie)) {
    return cookie;
  }
  deleteCookie('LANG');
  window.sessionStorage.setItem('LANG', 'gr');
  return 'gr';
};
const onLanguageChange = (newLanguage, oldLanguage, informUpdate = true) => {
  if (isValidLanguageValue(newLanguage) && newLanguage !== oldLanguage) {
    setCookie('LANG', newLanguage, 1);
    if(informUpdate){
      informLanguageChange();
    }
    return newLanguage;
  }
  return oldLanguage;
};
// ---------------------------------------------------------------------------------------------------------------

// ---------------------------------------------------------------------------------------------------------------

// ---------------------------------------------------------------------------------------------------------------
/** @type {React.Context<null | {isRepo2: boolean, lang: string, setLang: (string) => void}>} */
const GlobalContext = React.createContext(null);
// ---------------------------------------------------------------------------------------------------------------

/** @return {{isRepo2: boolean, lang: string, setLang: (string) => void}} */
const useInitGlobalContext = () => {
  const [lang, setLang] = useState(initLanguageValue());

  const onUiLanguageChange = (newLanguage) => {
    window.sessionStorage.setItem('LANG', newLanguage);
    setLang(onLanguageChange(newLanguage, lang));
  };

  return {lang: lang, setLang: onUiLanguageChange, isRepo2: true};
};
/** @return {{isRepo2: boolean, lang: string, setLang: (string) => void}}*/
export const useGlobalContext = () => {
  const params = useContext(GlobalContext);
  if (params == null) {
    throw new Error('Error: global context not initialized');
  }
  return params;
};
// ---------------------------------------------------------------------------------------------------------------
export const ContextProvider = ({ children }) => {
  const globalCtxValue = useInitGlobalContext();
  return <GlobalContext.Provider value={globalCtxValue}>{children}</GlobalContext.Provider>;
};
